import React from "react";
import PropTypes from "prop-types";

// Import all back side images
import back_side_1 from "../../../images/back_side/1.jpg";
import back_side_2 from "../../../images/back_side/2.jpg";
import back_side_3 from "../../../images/back_side/3.jpg";
import back_side_4 from "../../../images/back_side/4.jpg";
import back_side_5 from "../../../images/back_side/5.jpg";
import back_side_6 from "../../../images/back_side/6.jpg";
import back_side_7 from "../../../images/back_side/7.jpg";
import back_side_8 from "../../../images/back_side/8.jpg";
import back_side_9 from "../../../images/back_side/9.jpg";
import back_side_10 from "../../../images/back_side/10.jpg";
import back_side_11 from "../../../images/back_side/11.jpg";

// Import front side images for mouse enter functionality
import front_side_1 from "../../../images/front_side/1.jpg";

const BackBodyPart = ({
  backBodyPartValue = back_side_1,
  onClickBodyParts,
  handleMouseEnter,
  handleMouseLeave,
}) => {
  return (
    <div
      style={{
        borderWidth: 1,
        borderColor: "black",
      }}
      className="body_view_figure"
    >
      <img src={backBodyPartValue} alt="backBody" style={{ width: "100%" }} />

      {/* Head and Neck Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Head and Neck Back")}
        style={{
          top: "2%",
          left: "38.7%",
          width: "21.1%",
          height: "15%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_2)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Shoulder and Arm Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Shoulder and Arm Back")}
        style={{
          top: "18%",
          left: "19%",
          width: "13%",
          height: "16%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_3)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Shoulder and Arm Back")}
        style={{
          top: "18%",
          right: "19%",
          width: "13%",
          height: "16%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_3)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Elbows Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Elbows Back")}
        style={{
          top: "34%",
          left: "17%",
          width: "11%",
          height: "3.2%",
          transform: "rotate(6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_4)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Elbows Back")}
        style={{
          position: "absolute",
          top: "34%",
          right: "19%",
          width: "11%",
          height: "3.2%",
          cursor: "pointer",
          transform: "rotate(-6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_4)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Forearm wrist and hand back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand back")}
        style={{
          top: "37%",
          left: "13%",
          width: "12%",
          height: "11%",
          transform: "rotate(6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_5)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand back")}
        style={{
          top: "37%",
          right: "15%",
          width: "12%",
          height: "11%",
          transform: "rotate(-8deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_5)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand back")}
        style={{
          top: "47.5%",
          left: "5.5%",
          width: "14.5%",
          height: "10.5%",
          transform: "rotate(6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_5)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Forearm wrist and hand back")}
        style={{
          top: "47.5%",
          right: "8.5%",
          width: "14.5%",
          height: "10.5%",
          transform: "rotate(-6deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_5)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Upper Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Back")}
        style={{
          top: "15%",
          left: "38%",
          width: "22%",
          height: "1.5%",
          borderTopLeftRadius: "70%",
          borderTopRightRadius: "70%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_6)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Back")}
        style={{
          top: "16.5%",
          left: "30%",
          width: "38%",
          height: "15.5%",
          borderTopLeftRadius: "25%",
          borderTopRightRadius: "25%",
          borderBottomLeftRadius: "16%",
          borderBottomRightRadius: "16%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_6)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Lower Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Back")}
        style={{
          top: "31%",
          left: "32%",
          width: "35%",
          height: "11%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_7)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Pelvis Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Pelvis Back")}
        style={{
          top: "42%",
          left: "32%",
          width: "36%",
          height: "9.5%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_8)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Upper Leg Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Back")}
        style={{
          top: "51.5%",
          left: "30%",
          width: "19%",
          height: "10%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_9)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Back")}
        style={{
          top: "51.5%",
          right: "31%",
          width: "19%",
          height: "10%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_9)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Back")}
        style={{
          top: "61.5%",
          left: "31%",
          width: "18%",
          height: "8%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_9)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Upper Leg Back")}
        style={{
          top: "61.5%",
          right: "32%",
          width: "18%",
          height: "8%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_9)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Knees Back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Knees Back")}
        style={{
          top: "69.5%",
          left: "35%",
          width: "12%",
          height: "5%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_10)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Knees Back")}
        style={{
          top: "69.5%",
          right: "36%",
          width: "12%",
          height: "5%",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_10)}
        onMouseLeave={handleMouseLeave}
      />

      {/* Lower Legs and Feet back */}
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet back")}
        style={{
          top: "74.5%",
          left: "34%",
          width: "15%",
          height: "19%",
          transform: "rotate(-2deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_11)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet back")}
        style={{
          top: "74.5%",
          right: "36%",
          width: "15%",
          height: "19%",
          transform: "rotate(2deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_11)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet back")}
        style={{
          top: "93.2%",
          left: "30%",
          width: "16%",
          height: "5%",
          transform: "rotate(-2deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_11)}
        onMouseLeave={handleMouseLeave}
      />
      <button
        className="transbtn"
        onClick={() => onClickBodyParts("Lower Legs and Feet back")}
        style={{
          top: "93.2%",
          right: "32%",
          width: "16%",
          height: "5%",
          transform: "rotate(2deg)",
        }}
        onMouseEnter={() => handleMouseEnter(front_side_1, back_side_11)}
        onMouseLeave={handleMouseLeave}
      />
    </div>
  );
};

BackBodyPart.propTypes = {
  backBodyPartValue: PropTypes.string,
  onClickBodyParts: PropTypes.func.isRequired,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
};

export default BackBodyPart;
